export const getResults = (userTyped, actualWords, timeInSeconds) => {
  let correct = 0;
  let incorrectWords = [];
  let missedWords = [];

  let i = 0; // pointer for userTyped
  let j = 0; // pointer for actualWords

  while (i < userTyped.length && j < actualWords.length) {
    if (userTyped[i] === actualWords[j]) {
      correct++;
    } else {
      incorrectWords.push(`${userTyped[i]}•${actualWords[j]}`);
      missedWords.push(actualWords[j]);
    }
    i++;
    j++;
  }

  // Remaining words
  while (j < actualWords.length) missedWords.push(actualWords[j++]);
  while (i < userTyped.length) incorrectWords.push(userTyped[i++]);

  const totalTyped = userTyped.length;
  const accuracy = totalTyped > 0 ? Math.round((correct / totalTyped) * 100) : 0;
  const wpm = (totalTyped / (timeInSeconds / 60)).toFixed(2);

  return { totalTyped, correct, incorrectWords, missedWords, accuracy, wpm };
};